import { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Card, Button, Col, Row, Container, Tabs, Tab } from "react-bootstrap";
import { initializeSetOption } from "../../../../utils/InitializeSetDefault";
import { getServiceRequest } from "../../../../commons/ServiceRequest";
import { useAlert } from "../../../../context/AlertContext";
import { getQueryString } from "../../../../utils/Query";
import { HeadDetail } from "../../../../components/Perform/HeadDetail";
import { DetailEquip } from "../../../../components/Perform/DetailEquip";
import ServiceRequestService from "../../../../services/servicerequest.service";
import { useLoading } from "../../../../context/LoadingContext";
import { Helmet } from "react-helmet-async";
import { useWebsiteName } from "../../../../context/WebsiteNameContext";
import ReportHeadComponent from "../../../../components/ReportHeadComponent";
import { FloatingControlComponent } from "../../../../components/FormComponent";
import CardDisplayComponent from "../../../../components/CardDisplayComponent";

export default function DataServiceReport() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { loading, setLoading } = useLoading(false);
  const { websiteName, setWebsiteName } = useWebsiteName();
  const [previousData, setPreviousData] = useState([]);
  const [equipData, setEquipData] = useState([]);
  const [equipIndex, setEquipIndex] = useState(0);
  const [optionReason, setOptionReason] = useState([]);

  const [isAccecpt, setIsAccept] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const columns = {
    Standard: [{
      name: "detail",
      label: "ขั้นตอนการปฏิบัติงาน",
      type: "text",
      readOnly: true,
      width: "250px"
    },
    {
      name: "priority",
      label: "Priority",
      readOnly: true,
      width: "180px"
    },
    {
      name: "reason",
      label: "เหตุผลที่ข้ามขั้นตอน",
      type: "select",
      required: true,
      noneAsync: true,
      filterBy: ["Reason_Desc"],
      options: initializeSetOption({
        key: "Id",
        label: "Reason_Desc",
        dataset: optionReason
      }),
      width: "250px"
    },
    {
      name: "",
      label: "เพิ่มรูป",
      type: "addImage"
    },
    {
      name: "",
      label: "ดูรูปภาพ",
      type: "viewImage"
    },
    {
      name: "remark",
      label: "หมายเหตุ",
      type: "text"
    },
    ],
    Record: [
      {
        name: "detail",
        label: "ขั้นตอนการปฏิบัติงาน",
        type: "text",
        readOnly: true,
        width: "350px"
      },
      {
        name: "standard_value",
        label: "ค่ามาตรฐาน",
        readOnly: true,
      },
      {
        name: "record_value",
        label: "ค่าที่จดบันทึก",
      },
      {
        name: "unit",
        label: "หน่วย",
        width: "100px",
        readOnly: true
      },
      {
        name: "",
        label: "เพิ่มรูป",
        type: "addImage"
      },
      {
        name: "",
        label: "ดูรูปภาพ",
        type: "viewImage"
      },
      {
        name: "remark",
        label: "หมายเหตุ",
      },
    ],
    Check: [
      {
        name: "equip_no",
        label: "รหัสอุปกรณ์/อะไหล่",
        type: "text",
        width: "200px",
        readOnly: true
      },
      {
        name: "equip_detail",
        label: "รายละเอียดอุปกรณ์/อะไหล่",
        readOnly: true,
        width: "250px"
      },
      {
        name: "model_number",
        label: "Model Number",
        readOnly: true,
        width: "180px"
      },
      {
        name: "lumsum",
        label: "สัญญา LumSum",
        width: "200px",
        readOnly: true
      },
      {
        name: "expire_date",
        label: "วันหมดอายุ",
        readOnly: true,
      },
      {
        name: "check_date",
        label: "วันที่เช็คเปลี่ยน",
        readOnly: true
      },
      {
        name: "next_start",
        label: "วันที่เปลี่ยนครั้งต่อไประหว่าง",
        width: "250px",
        readOnly: true
      },
      {
        name: "end_start",
        label: "ถึงวัน",
        readOnly: true
      },
      {
        name: "plan_status",
        label: "สถานะตามแผน",
        readOnly: true
      },
      {
        name: "actual_status",
        label: "สถานะจริง",
        type: "select",
        noneAsync: true,
        filterBy: ["Status"],
        options: initializeSetOption({
          key: "Status",
          label: "Status",
          dataset: [
            { Status: "เช็ค" },
            { Status: "เปลี่ยน" }
          ]
        })
      },
      {
        name: "detail",
        label: "รายละเอียดการทำงาน",
        type: "select",
        noneAsync: true,
        filterBy: ["Status"],
        options: initializeSetOption({
          key: "Status",
          label: "Status",
          dataset: optionReason
        }),
        width: "250px",
      },
      {
        name: "use_num",
        label: "จำนวนที่ใช้",

      },
      {
        name: "use",
        label: "Use Flag",
        type: "select",
        noneAsync: true,
        filterBy: ["Status"],
        options: optionReason,
        options: initializeSetOption({
          key: "Status",
          label: "Status",
          dataset: [
            { Status: "Y", Use: true },
            { Status: "N", Use: false }
          ]
        })
      },
      {
        name: "",
        label: "เพิ่มรูปก่อนทำ",
        type: "addImage",
        width: "140px",
      },
      {
        name: "",
        label: "ดูรูปก่อนทำ",
        type: "viewImage",
        width: "140px",
      },
      {
        name: "",
        label: "เพิ่มรูปหลังทำ",
        type: "addImage",
        width: "140px",
      },
      {
        name: "",
        label: "ดูรูปหลังทำ",
        type: "viewImage",
        width: "140px",
      },
    ],
    Special: [
      {
        name: "detail",
        label: "รายละเอียดข้อกำหนดเพิ่มเติมตามสัญญา",
        type: "text",
        width: "400px",
        readOnly: true
      },
      {
        name: "other",
        label: "ข้อกำหนดเพิ่มเติมอื่นๆ",
        readOnly: true,
        width: "300px"
      },
      {
        name: "pm_no",
        label: "PM/ครั้งที่",
        readOnly: true,
        width: "180px"
      },
    ]
  }

  const inputField = {
    headerReport: [
      {
        name: "Bill_Doc_No",
        label: "เลขที่ใบรายงานบริการ",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 12,
      },
      {
        name: "Bill_Doc_No",
        label: "วันที่ปฏิบัติงาน",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 6
      },
      {
        name: "Bill_Doc_No",
        label: "เวลา",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 6
      },
    ],
    Inform: [
      {
        name: "Request_Name",
        label: "รหัสลูกค้า (BP Code)",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 4
      },
      {
        name: "แผนก",
        label: "รหัสสาขา",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 2
      },
      {
        name: "Seq_No",
        label: "ชื่อลูกค้า/สาขา",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 6
      },
      {
        name: "Ref_Do_No",
        label: "เลขที่ใบสั่งงาน",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "4"
      },
      {
        name: "Cus_Code",
        label: "PM ครั้งที่",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 1
      },
      {
        name: "Cus_Name",
        label: "Sq.",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 1
      },
      {
        name: "Project_No",
        label: "ชื่อสินค้า",
        classNames: { col: "mb-3", label: "mb-1" },
        format: (row) => formatDate(row),
        size: 3
      },
      {
        name: "Req_Date",
        label: "หมายเลขเครื่อง (Serial No.)",
        classNames: { col: "mb-3", label: "mb-1" },
        format: (row) => formatTime(row),
        size: 3
      },
      {
        name: "Branch_No",
        label: "จุดที่ตั้งเครื่องจักร",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 6,
      },
      {
        name: "Branch_Name",
        label: "เลขที่ปฏิบัติงาน",
        size: "7",
        classNames: { col: "mb-3", label: "mb-1" },
        format: (row) => formatDate(row),
        size: 3
      },
      {
        name: "Time",
        label: "หมายเลข Ticket ลูกค้า",
        classNames: { col: "mb-3", label: "mb-1" },
        format: (row) => formatTime(row),
        size: 3
      },
    ],
    Other: [
      { name: "Printed_By", label: "ช่างผู้ปฏิบัติงาน" },
      { name: "Approver", label: "วันที่ปฏิบัติงาน" },
      { name: "Approver", label: "ลายเซ็นลูกค้า" }
    ]
  };
  const showData = (field) => {
    return field.map(
      (
        { name, label, size, classNames, style, findValue },
        idx
      ) => {
        // let joinData = formatSplitKey(name, ".", Seq);
        var parts = name.split(".");
        // const result = currentData ? (parts.length == 1 ? currentData[name]
        //   : currentData[parts[0]][parts[1]]) : ""
        return (
          <Col
            key={idx}
            sm={size ? size : size === null ? null : 3}
            className={classNames?.col}
          >
            {name && (
              <FloatingControlComponent
                readOnly
                type="text"
                name={name}
                label={label}
                className={classNames}
                style={style}
              // value={result}
              />
            )}
          </Col>
        );
      }
    );
  };

  function initEquipment(data, defaultData) {
    const [main] = data?.map((items) => {
      return {
        Seq_No: items.SeqOthersJob?.Seq_Oth_No ||
          items.SeqPmJob?.Seq_Pm_No ||
          items.SeqRepairJob?.Seq_Serv_No ||
          items.SeqInstallJob?.Seq_Inst_No,
        Job_Type: items.Job_Type_Name,
        No: "",
        Sq: "", //prod_set_mc.seq_work
        Item_Name: items.BillOfReqDt[0]?.Item.Item_Name_TH || items.BillOfReqDt[0]?.Item.Item_Name_EN,
        Project_No: items.Project_No,
        Start: "", //job_start_date
        End: "",
        Ticket: "", //cus_ticket_no
        Location: "", //prod_set_mc.mc_ location
      }
    });
    const newArray = []
    data?.length && data[0].BillOfReqDt?.map(ele => {
      newArray.push({
        ...main,
        Id: ele.Id,
        tableCheck: [{
          id: ele.Id,
          equip_no: ele.Item.Item_Code,
          equip_detail: ele.Item.Item_Name_TH || ele.Item.Item_Name_EN,
          model_number: ele.Item.Item_Model,
          lumsum: ele.ChildBom?.Foc?.FOC_ReasonName,
          expire_date: "",
          check_date: "",
          next_start: "",
          end_start: "",
          plan_status: "",
          actual_status: "",
          detail: ele.ChildBom?.Foc?.FOC_ReasonName,
          use_num: "",
          use: ele.Use_Status,
          // "contract_foc_hd_id": 1,
          // "tech_insp_rev_id": 3,
          file: []
        }],
        ...defaultData
      })
    })

    setEquipData(newArray || [])
  }

  const { seq_no } = useParams()
  useEffect(() => {
    setPreviousData(state?.data)
    getData()
  }, [])

  function getData() {
    // const page = search?.page || currentPage
    const q = getQueryString({
      seq_no,
      page: 1,
      limit: 100
    })

    let tableData = {}
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ServiceRequestService.getItemStepDes(q),
      callback: (res) => {
        const arrayStep = res.map(el => ({
          id: el.Id,
          item_step_des_id: el.Item_Step_Id,
          detail: el.Item_Step_Des,
          priority: el.Item_Step_Priority,
          reason: el.Item_Step_Reason,
          remark: "",
          file: []
        }))
        tableData = { ...tableData, tableStandard: arrayStep }
      }
    });
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ServiceRequestService.getContractSpec(q),
      callback: (res) => {
        const arraySp = res.map(el => ({
          detail: el.Con_Spec_Des,
          other: el.remark,
          pm_no: el.PM_Of_Work,
          id: el.Id,
        }))
        tableData = { ...tableData, tableSpecial: arraySp }
      }
    });
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ServiceRequestService.getStandardRec(q),
      callback: (res) => {
        const array = res.map(item => ({
          detail: item.Item_Record_Des,
          standard_value: item.Record_Value,
          record_value: item.Actual_Value,
          unit: item.Record_UOM,
          remark: item.Remark,
          id: item.Id,
          file: []
        }))
        tableData = { ...tableData, tableRecord: array }
      }
    });

    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ServiceRequestService.getFindJobItem(q),
      callback: (res) => { initEquipment(res.data, tableData); }
    });

    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ServiceRequestService.getReason(q),
      callback: (res) => { setOptionReason(res) }
    });

  }
  function onChangeCallback(data) {
    setEquipData(data)
  }

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Perform Service Request Page" />
      </Helmet>

      <Container fluid className="p-0" id="tab_team">
        <Tabs
          justify
          defaultActiveKey={state?.name || "CloseJob"}
          className="mb-3"
        >
          <Tab eventKey="ServiceReq" title="ปฏิบัติงานตาม Service Request" disabled>
          </Tab>
          <Tab eventKey="ServiceReqDetail" title="ข้อมูลการปฏิบัติงานตาม Service Request" disabled>
          </Tab>
          <Tab eventKey="CloseJob" title="ปิดงาน">

            <Card className="m-1 mb-4 p-4 border-0">
              <Card.Body>
                <div className="pb-4 fs-2 text-center">
                  รายละเอียดการทำงาน
                </div>

                <Row>
                  <Col
                    sm={9}
                    className="ReportHead mb-3 d-flex align-items-center"
                  >
                    <ReportHeadComponent formName="Service Request Form" />
                  </Col>

                  <Col as={Row} className="mb-3">
                    {showData(inputField.headerReport)}
                  </Col>

                  {showData(inputField.Inform)}
                </Row>
              </Card.Body>
            </Card>

            <DetailEquip
              data={equipData}
              columns={columns}
              setEquipData={setEquipData}
              equipIndex={equipIndex}
              setEquipIndex={setEquipIndex}
              onChangeCallback={onChangeCallback}
              isReport
            />

            <CardDisplayComponent
              body={{
                as: Row,
                className: "justify-content-around ",
                element: inputField.Other.map(({ name, label }) => (
                  <Col key={name} sm={3}>
                    <FloatingControlComponent
                      readOnly
                      type="text"
                      name={name}
                      label={label}
                    // value={formatSplitKey(name, ".", currentData)}
                    />
                  </Col>
                ))
              }}
            />

            <Card className="m-1 mb-4 p-4 border-0">
              <Row className="justify-content-center mt-3">
                <Col className="col-auto">
                  <Button
                    variant="outline-secondary"
                    className="ms-2 px-5 mb-3 py-2 text-dark border-dark border-opacity-50 rounded-pill"
                    onClick={() => navigate("/service_work/perform", {
                      state: { name: "CloseJob" }
                    })}
                  >
                    ย้อนกลับ
                  </Button>
                </Col>
              </Row>
            </Card>

          </Tab>
        </Tabs>
      </Container>
    </>
  );
}